var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M30 60C13.431 60 0 46.569 0 30S13.431 0 30 0s30 13.431 30 30-13.431 30-30 30m0-2c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28m0-47 19 32H11zm0 4.3L15 41h30zM29 24h2v10h-2zm0 12h2v2h-2z"
  })));
});
const SvgBigAlertIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBigAlertIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjBweCIgaGVpZ2h0PSI2MHB4IiB2aWV3Qm94PSIwIDAgNjAgNjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbC1ydWxlPSJldmVub2RkIj4KCQk8ZyBpZD0iYmlnX2Vycm9yX2ljb24iPgoJCQk8cGF0aCBkPSJNMzAsNjAgQzEzLjQzMTQ1NzUsNjAgMCw0Ni41Njg1NDI1IDAsMzAgQzAsMTMuNDMxNDU3NSAxMy40MzE0NTc1LDAgMzAsMCBDNDYuNTY4NTQyNSwwIDYwLDEzLjQzMTQ1NzUgNjAsMzAgQzYwLDQ2LjU2ODU0MjUgNDYuNTY4NTQyNSw2MCAzMCw2MCBaIE0zMCw1OCBDNDUuNDYzOTczLDU4IDU4LDQ1LjQ2Mzk3MyA1OCwzMCBDNTgsMTQuNTM2MDI3IDQ1LjQ2Mzk3MywyIDMwLDIgQzE0LjUzNjAyNywyIDIsMTQuNTM2MDI3IDIsMzAgQzIsNDUuNDYzOTczIDE0LjUzNjAyNyw1OCAzMCw1OCBaIE0zMCwxMSBMNDksNDMgTDExLDQzIEwzMCwxMSBaIE0zMCwxNS4zMDAwMDAyIEwxNSw0MSBMNDUsNDEgTDMwLDE1LjMwMDAwMDIgWiBNMjksMjQgTDMxLDI0IEwzMSwzNCBMMjksMzQgTDI5LDI0IFogTTI5LDM2IEwzMSwzNiBMMzEsMzggTDI5LDM4IEwyOSwzNiBaIj48L3BhdGg+CgkJPC9nPgogICAgPC9nPgo8L3N2Zz4=";